import { extend } from 'vee-validate';

extend('isValidPhone', {
  validate: (flag: boolean) => !!flag,
  message: 'El teléfono no es válido',
});
